import {BasicSymbol, SymbolStates} from "./BasicSymbol";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class XWaySymbol extends BasicSymbol {
    private startValue: number = 1;
    private revealSymContainer: PIXI.Container;
    private revealSym: string = "";
    private lockSpine: PIXI.spine.Spine;
    private lockSprite: PIXI.Sprite;
    private multipler: PIXI.BitmapText;
    private whiteFontEffect: PIXI.BitmapText;
    private revealSymSprite: PIXI.Sprite;
    private revealSymFrame: PIXI.Sprite;
    private revealSymFrameSHadow: PIXI.Sprite;
    private xwAnimName = "";
    private winEffect: TimelineSprite | null;
    private currentAnchor: number;

    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition) {
        super(symbolName, initState, reel, symbolPosition);
        this.load();
        this.getStateAnimation(initState);

    }

    private _scaleDirection: string;

    get scaleDirection(): string {
        return this._scaleDirection;
    }

    set scaleDirection(value: string) {
        this._scaleDirection = value;
    }

    public getStateAnimation(state: SymbolStates): gsap.core.Timeline {
        let tl: gsap.core.Timeline = gsap.timeline();
        switch (state) {
            case SymbolStates.SPIN:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.setSpriteTexture("_spin");
                this.moveToNormalLayer();
                break;
            case SymbolStates.START_SPIN:
                tl.add(() => {
                    this.state = state;
                    this.mainSpine!.visible = false;
                }, 0);
                this.moveToNormalLayer();
                break;
            case SymbolStates.LANDING:
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.playLandingAnim(), 0);
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XWAY_LAND);
                }, 0.005);
                break;
            case SymbolStates.NO_WIN:
                tl.add(() => this.moveToNormalLayer(),0);
                // tl.add(this.showNoWinOverlay(XwaysHoarder2Statics.noWinTint, 0.3, 0.75, PIXI.BLEND_MODES.MULTIPLY, false));
                break;
            case SymbolStates.WIN:
                tl.add(() => {
                    this.state = state;
                    this.moveToWinLayer();
                }, 0);
                tl.add(this.playWinAnimation());
                break;
            case SymbolStates.REVEAL:
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.revealAnimation());
                break;
            case SymbolStates.WIN_TOGGLE:
                break;
            case SymbolStates.REMOVED:
                break;
            case SymbolStates.UNSTICKY:
                tl.add(() => {
                    this.state = state;
                    this.moveToNormalLayer();
                }, 0);
                tl.add(this.unlockXWAnimation(), 0);
                break;
            case SymbolStates.STICKY:
                tl.add(() => {
                    this.state = state;
                    this.isOldSym = true;
                    this.moveToStickyLayer();
                }, 0);
                tl.add(this.lockAnimation(), 0);
                tl.add(this.hideXwaysSize(), 0);
                break;
            case SymbolStates.SPLIT: //only change sprite states
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.showSplitAnim());
                break;
            case SymbolStates.SCALED:
                tl.add(() => {
                    this.state = state;
                    this.moveToWinLayer();
                }, 0);
                tl.add(this.scaleAnimation());
                tl.add(() => {
                    this.moveToNormalLayer();
                }, ">")
                break;
            case SymbolStates.REVERSE_SCALED:
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.reverseScaleAnimation());
                break;
            case SymbolStates.REVERT:
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.revertBackAnimation());
                break;
            default:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.moveToNormalLayer();
                this.setSpriteTexture("");
        }
        return tl;
    }

    public revealXwaysSize(initialRevealValue: number): gsap.core.Timeline {
        const sizeTl: gsap.core.Timeline = gsap.timeline();
        if (initialRevealValue > 1) {
            sizeTl.add(() => {
                this.multipler.text = `${initialRevealValue}x`;
                this.multipler.visible = true;
                this.multipler.alpha = 0;
                this.multipler.scale.set(0, 0);
                this.multipler.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.visualHeightStatus - 40);
                this.startValue = initialRevealValue;
                this.symbolSize = initialRevealValue;
            }, 0);
            sizeTl.to(this.multipler, {alpha: 1, duration: 0.15}, 0.005);
            sizeTl.to(this.multipler.scale, {x: 1, y: 1, duration: 0.15}, "<");
        }
        return sizeTl;
    }

    public hideXwaysSize(): gsap.core.Timeline {
        const hideTl: gsap.core.Timeline = gsap.timeline();
        if (this.startValue > 1) {
            hideTl.to(this.multipler, {alpha: 0, duration: 0.15}, 0);
            hideTl.to(this.multipler.scale, {x: 0, y: 0, duration: 0.15}, "<");
            hideTl.add(() => {
                this.startValue = 1;
                this.multipler.visible = false;
                this.multipler.text = "";
            });
        }

        return hideTl;
    }

    public mergeEndAnimation(newSymbolHeight: number): gsap.core.Timeline {//only switch mainSpirte Image
        const mergeTl: gsap.core.Timeline = gsap.timeline();
        this.symbolHeight = newSymbolHeight;
        this.visualHeightStatus = 200 * newSymbolHeight;
        let textureName: string = newSymbolHeight === 2 ? "_double" : "_triple";
        mergeTl.add(() => {
            this.setSpriteTexture(textureName);
            this.mainSprite.anchor.set(0.5, 0.5);
            this.mainSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.visualHeightStatus * 0.5);
        }, 0);

        return mergeTl;
    }

    public playWinAnimation(): gsap.core.Timeline {
        const winTL: gsap.core.Timeline = gsap.timeline();
        this.winEffect = new TimelineSprite(XwaysHoarder2.assetLoader.getTextures(`winGlow_${this.visualHeightStatus}`));
        this.winEffect.name = `winEffect_${this.visualHeightStatus}`;
        this.winEffect.anchor.set(0.5, 0.5);
        this.winEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
        this.winEffect.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.addScaleYPos());
        this.winEffect.hide();
        this.overlayContainer.addChild(this.winEffect);
        winTL.add(<gsap.core.Timeline><unknown>this.winEffect.getAnimationAutoShowHide());
        winTL.add(() => {
            //TODO maybe remove this if next mode is not normal
        });
        return winTL;
    }

    private scaleAnimation(): gsap.core.Timeline {
        const scaleTl: gsap.core.Timeline = gsap.timeline();
        let expectedHeight: number = XwaysHoarder2.model.endSpinHeights[this.reel.id][this.symID];
        if (this.visualHeightStatus != expectedHeight) {
            let currentImgName: string = this.visualHeightStatus === 200 ? "XW" : "XW_double";
            const crntImg: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`XW/${currentImgName}`)[0]);
            crntImg.name = "xwCopy";
            crntImg.anchor.set(0.5);
            this.mainSpriteContainer.addChild(crntImg);
            this.mainSprite.alpha = 0;

            this.visualHeightStatus = expectedHeight;

            if (this.symID === 0) {
                this.currentAnchor = 0;
                this.mainSprite.position.y = 0;
                this.mainSprite.anchor.y = crntImg.anchor.y = this.currentAnchor;
                crntImg.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, 0);
            } else if (this.symID === 1) {
                // this.mainSprite.position.y -= 100;
                expectedHeight === 400 ? this.currentAnchor = 0.5 : this.currentAnchor = 1;
                this.mainSprite.anchor.y = crntImg.anchor.y = this.currentAnchor;
                crntImg.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, expectedHeight === 400 ? 100 : 400);
                if (expectedHeight === 500) {
                    this.mainSprite.position.y = 400;
                }
            } else if (this.symID === 2) {
                this.currentAnchor = 1;
                this.mainSprite.position.y += 100;
                this.mainSprite.anchor.y = this.currentAnchor;
                crntImg.anchor.y = this.currentAnchor;
                crntImg.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, 200);
            }

            // scaleTl.to(crntImg, {alpha: 1, duration: 0.001}, 0);
            scaleTl.to(crntImg.scale, {y: expectedHeight === 400 ? 2 : 1.25, duration: 0.2, ease: "power2.out."}, 0);
            scaleTl.add(() => {
                this.setSpriteTexture(expectedHeight === 400 ? "_double" : "_2_5");
            }, 0);
            scaleTl.to(this.mainSprite, {alpha: 1, duration: 0.01}, 0.18);
            scaleTl.to(crntImg, {alpha: 0, duration: 0.001}, 0.189);
            scaleTl.add(() => {
                this.mainSpriteContainer.removeChild(crntImg);
            }, scaleTl.duration());
            if (this.symID !== 2) {
                let multiYPos: number = this.multipler.position.y;
                if (this.symID == 0) {
                    multiYPos = this.visualHeightStatus - 40;
                } else {
                    multiYPos += (this.visualHeightStatus - this.symbolHeight * 200) / 2;
                    if (this.symbolHeight == 2) {
                        multiYPos -= 50;
                    }
                }
                scaleTl.to(this.multipler.position, {duration: 0.2, y: multiYPos}, 0)
            }


        }

        return scaleTl;
    }

    private lockAnimation(): gsap.core.Timeline {
        const xwLockTL: gsap.core.Timeline = gsap.timeline();
        const animName: string = this.visualHeightStatus === 200 ? "1x1_Lock" : this.visualHeightStatus === 400 ? "2x1_Lock" : "3x1_Lock";

        xwLockTL.add(() => {
            this.lockSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.visualHeightStatus * 0.5);
            this.lockSpine!.visible = true;
        }, 0.005);
        xwLockTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.lockSpine!, 0, animName, false).timeScale(2), 0);
        xwLockTL.add(() => {
            this.lockSpine!.visible = false;
            this.lockSprite.texture = XwaysHoarder2.assetLoader.getTextures(`lock_${this.visualHeightStatus}`)[0];
            this.lockSprite.anchor.set(0.5);
            this.lockSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.visualHeightStatus * 0.5);
            this.lockSprite!.visible = true;
        }, ">")
        return xwLockTL;
    }

    private unlockXWAnimation(): gsap.core.Timeline {
        const xwUnlclTL: gsap.core.Timeline = gsap.timeline();
        const animName: string = this.visualHeightStatus === 200 ? "1x1_Off" : this.visualHeightStatus === 400 ? "2x1_Off" : "3x1_Off";
        if (this.state === SymbolStates.STICKY) {
            xwUnlclTL.add(() => {
                this.lockSprite.visible = false;
                this.lockSpine.visible = true;
            }, 0);
            xwUnlclTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.lockSpine, 0, animName, false).timeScale(1), 0);
            xwUnlclTL.add(() => {
                this.lockSprite.visible = false;
                this.lockSpine.visible = false;
            }, ">")
        }
        return xwUnlclTL;
    }

    private load() {

        this.revealSymContainer = new PIXI.Container();
        this.revealSymContainer.name = "symbolRevealContainer";
        // XW specifics


        this.mainSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XW_SPINE));
        this.mainSpine.visible = false;
        this.mainSpine.name = `${this.symbolName}mainSpine`;
        this.mainSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);


        this.view.addChild(this.mainSpriteContainer);
        this.view.addChild(this.revealSymContainer);
        this.view.addChild(this.mainSpine);
        this.addMultiplier();
        this.view.addChild(this.overlayContainer);


        this.visualHeightStatus = 200;
        this.isSticky = false;
        this.isOldSym = false; //doesnt matter in restore
        this.symbolHeight = 1;//no of space it fills in terms of symbol count in a reel
        this.splitAnimOn = false;
        this.isSplitted = false;
        this.symbolSize = 1;//multiplier counter
        this.noWinOverlay = null; //create according to size
        this.winEffect = null;
        this.currentAnchor = 0.5;

        this.addLockAssets();
    }

    private revealAnimation(): gsap.core.Timeline {
        const revealTl: gsap.core.Timeline = gsap.timeline();
        //add scale anim first
        this.revealSym = XwaysHoarder2.model.data.evaluatedArea[this.reel.id][this.symID];
        this.createRevealSymAssets();
        revealTl.add(() => {
            this.mainSpine!.visible = true;
            this.mainSpine!.alpha = 0;
            this.mainSpine!.position.y = this.addScaleYPos();
            this.revealSymSprite.addChild(this.revealSymFrameSHadow, this.revealSymFrame);
            this.revealSymContainer.addChild(this.revealSymSprite);
        }, 0);
        revealTl.to(this.mainSpine!, {alpha: 1, duration: 0.001}, 0);
        revealTl.to(this.revealSymSprite, {alpha: 1, duration: 0.002}, 0);
        revealTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, this.xwAnimName + "_Open", false), 0);
        revealTl.to(this.mainSprite, {alpha: 0, duration: 0.001}, 0.001);
        revealTl.add(() => {
            this.mainSpine!.visible = false;
        }, revealTl.duration());

        return revealTl;
    }

    private addLockAssets(): void {
        this.lockSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SYM_LOCK));
        this.lockSpine.visible = false;
        this.lockSpine.name = "lockTapeSpine";
        this.lockSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.visualHeightStatus * 0.5);

        this.lockSprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`lock_${this.visualHeightStatus}`)[0]);
        this.lockSprite.visible = false;
        this.lockSprite.name = "lockTapeImg";
        this.lockSprite.anchor.set(0.5, 0.5);
        this.lockSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.visualHeightStatus * 0.5);
        this.view.addChild(this.lockSprite, this.lockSpine);
    }

    private addMultiplier(): void {
        this.multipler = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER,
            fontSize: 32,
        });
        this.multipler.anchor = new PIXI.Point(0.5, 0.5);
        this.multipler.visible = false;
        this.multipler.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight - 40);

        this.whiteFontEffect = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.MULTIPLIER_WHITE,
            fontSize: 32,
        });
        this.whiteFontEffect.anchor = new PIXI.Point(0.5, 0.5);
        this.whiteFontEffect.position.set(0, 0);
        this.whiteFontEffect.alpha = 0;
        this.multipler.addChild(this.whiteFontEffect);
        this.view.addChild(this.multipler);
    }

    private playLandingAnim(): gsap.core.Timeline {
        const landingTl: gsap.core.Timeline = gsap.timeline();
        landingTl.to(this.mainSprite, {alpha: 0, duration: 0.005});
        this.moveToNormalOverLayer();
        landingTl.add(() => {
            this.mainSpine!.visible = true;
            this.setSpriteTexture("");
        }, 0.005);
        landingTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "1x1_Land", false), 0);
        landingTl.to(this.mainSprite, {alpha: 1, duration: 0.005}, ">-0.2");
        landingTl.add(() => {
            this.mainSpine!.visible = false;
        }, SpineGSAPWrapper.animationTimeDuration(this.mainSpine!,"1x1_Land"));

        return landingTl;
    }

    private createRevealSymAssets(): void {
        let textureName: string = "";
        let frameName: string = "";
        let currentValue: number = JSON.parse(JSON.stringify(this.symbolSize));
        if (this.visualHeightStatus === 200) {
            textureName = "";
            frameName = "x1frame";
            this.xwAnimName = "1x1";
        } else if (this.visualHeightStatus === 400) {
            textureName = "_2x1";
            frameName = "x2frame";
            this.xwAnimName = "2x1";
            if (this.revealSym.includes("L") && (currentValue === 2 || currentValue === 3)) {
                textureName = "_bg2x1";
            }
        } else if (this.visualHeightStatus === 500) {
            textureName = "_2_5x1";
            frameName = "x2_5frame";
            this.xwAnimName = "2_5x1";
            if (this.revealSym.includes("L") && (currentValue === 2 || currentValue === 3)) {
                textureName = "_bg2_5x1";
            }

        } else if (this.visualHeightStatus === 600) {
            textureName = "_3x1";
            frameName = "x3frame";
            this.xwAnimName = "3x1";
            if (this.revealSym.includes("L") && (currentValue === 2 || currentValue === 3)) {
                textureName = "_bg3x1";
            }
        }


        this.revealSymSprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.revealSym, textureName))[0]);
        this.revealSymSprite.name = `revealedSym_${this.revealSym}`;
        this.revealSymSprite.anchor.set(0.5, 0.5);
        this.revealSymSprite.alpha = 0;
        this.revealSymSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.addScaleYPos());

        if (this.visualHeightStatus > 200) {
            if (this.revealSym.includes("L") && (currentValue === 2 || currentValue === 3)) {
                const lowSymContainer: PIXI.Container = new PIXI.Container();
                lowSymContainer.name = "lowsymCOntainer"
                lowSymContainer.position.set(0, -this.visualHeightStatus / 4);
                this.revealSymSprite.addChild(lowSymContainer);

                for (let i: number = 0; i < currentValue; i++) {
                    const img: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.revealSym, "_fg"))[0]);
                    img.anchor.set(0.5, 0.5);
                    img.scale.set(0.85,0.85);
                    img.position.x = 0;
                    if (i === 0) {
                        img.position.y = 0;
                    } else if (i === JSON.parse(JSON.stringify(currentValue)) - 1) {
                        if (this.visualHeightStatus === 400) {
                            img.position.y = 200;
                        } else if (this.visualHeightStatus === 500) {
                            img.position.y = 250;
                        } else if (this.visualHeightStatus === 600) {
                            img.position.y = 300;
                        }
                    }
                    if (currentValue === 3 && i === 1) {
                        if (this.visualHeightStatus === 400) {
                            img.position.y = 100;
                        } else if (this.visualHeightStatus === 500) {
                            img.position.y = 125;
                        } else if (this.visualHeightStatus === 600) {
                            img.position.y = 150;
                        }
                    }
                    lowSymContainer.addChild(img);
                }
            }
        }

        this.revealSymFrameSHadow = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`xWayRevealShadow_${this.visualHeightStatus}`)[0]);
        this.revealSymFrameSHadow.name = "frameshadow";
        this.revealSymFrameSHadow.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this.revealSymFrameSHadow.anchor.set(0.5, 0.5);
        this.revealSymFrameSHadow.position.set(0, 0);

        this.revealSymFrame = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`XW/${frameName}`)[0]);
        this.revealSymFrame.name = "XW_frame";
        this.revealSymFrame.anchor.set(0.5, 0.5);
        this.revealSymFrame.position.set(0, 0);

    }

    private revertBackAnimation(): gsap.core.Timeline {
        const revertTl: gsap.core.Timeline = gsap.timeline();
        // remove scaled height
        //add scale anim first

        revertTl.add(() => {
            this.mainSpine!.visible = true;
            this.mainSpine!.alpha = 0;
        }, 0);
        revertTl.to(this.mainSpine!, {alpha: 1, duration: 0.001}, 0);
        revertTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, this.xwAnimName + "_Close", false), 0);
        revertTl.to(this.mainSprite, {alpha: 1, duration: 0.001}, 0.001);
        revertTl.add(() => {
            this.revealSymContainer.removeChild(this.revealSymSprite);
            this.revealSymSprite.destroy();
        })
        return revertTl;
    }

    private showSplitAnim(): gsap.core.Timeline {
        const symSplitTl: gsap.core.Timeline = gsap.timeline();
        this.isSplitted = true;
        symSplitTl.add(this.playSplitReelAnim(), 0);
        symSplitTl.add(this.multiplierUpdateAnimation(),"<")
        return symSplitTl;
    }

    private multiplierUpdateAnimation(): gsap.core.Timeline {
        const updateTL: gsap.core.Timeline = gsap.timeline();
        updateTL.to(this.multipler.scale, {x: 0.9, y: 0.9, duration: 0.333}, 0);
        updateTL.to(this.multipler.scale, {x: 1.4, y: 1.4, duration: 0.033});
        updateTL.addLabel("showWhiteFont");
        updateTL.to(this.whiteFontEffect, {alpha: 1, duration: 0.00001}, "showWhiteFont");
        updateTL.to(this.whiteFontEffect, {alpha: 0, duration: 0.165}, ">");
        updateTL.to([this.multipler.scale, this.whiteFontEffect.scale], {x: 0.9, y: 0.9, duration: 0.132}, "showWhiteFont");
        updateTL.to([this.multipler.scale, this.whiteFontEffect.scale], {x: 1, y: 1, duration: 0.033},">");

        updateTL.add(() => {
            this.symbolSize = this.symbolSize * 2;
            this.multipler.text = `${this.symbolSize}x`;
            this.whiteFontEffect.text = `${this.symbolSize}x`;
            this.multipler.addChild(this.whiteFontEffect);
        }, "showWhiteFont");


        return updateTL;
    }

    private playSplitReelAnim(): gsap.core.Timeline {
        const splitFlashTl: gsap.core.Timeline = gsap.timeline();
        const splitReelSpine: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SPLIT_REEL));
        splitReelSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, this.addScaleYPos());
        let animName: string = "";
        if (this.visualHeightStatus === 200) {
            animName = "1x1";
        } else if (this.visualHeightStatus === 400) {
            animName = "1x2";
        } else if (this.visualHeightStatus === 500) {
            animName = "1x2.5";
        } else if (this.visualHeightStatus === 600) {
            animName = "1x3";
        }
        splitFlashTl.add(() => {
            this.view.addChild(splitReelSpine);
        }, 0.005);
        splitFlashTl.add(SpineGSAPWrapper.createTimelineForAnimation(splitReelSpine, 0, animName, false), 0);
        splitFlashTl.add(() => {
            this.view.removeChild(splitReelSpine);
        }, ">");

        return splitFlashTl;
    }

    private reverseScaleAnimation(): gsap.core.Timeline {
        const rvrseTL: gsap.core.Timeline = gsap.timeline();
        let ogHeight: number = 200;

        if (this.symbolHeight === 1) {
            ogHeight = 200;
        } else if (this.symbolHeight === 2) {
            ogHeight = 400;
        } else if (this.symbolHeight === 3) {
            ogHeight = 600;
        }
        if (this.visualHeightStatus !== ogHeight) {

            let currentImgName: string = this.visualHeightStatus === 400 ? "XW_double" : "XW_2_5";
            const crntImg: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`XW/${currentImgName}`)[0]);
            crntImg.name = "xwReverseCopy";
            crntImg.anchor.set(0.5);

            rvrseTL.add(() => {
                this.mainSprite.alpha = 0;
            }, 0);

            if (this.symID === 0) {
                crntImg.anchor.y = 0;
                crntImg.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, 0);
            } else if (this.symID === 1) {
                ogHeight === 200 ? crntImg.anchor.y = 0.5 : crntImg.anchor.y = 1;
                crntImg.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, ogHeight === 200 ? 100 : 400);
            } else if (this.symID === 2) {
                crntImg.anchor.y = 1;
                crntImg.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, 200);
            }
            this.mainSpriteContainer.addChild(crntImg);


            let textureName: string = ogHeight === 200 ? "" : ogHeight == 400 ? "_double" : "_triple";
            rvrseTL.to(crntImg.scale, {y: ogHeight === 200 ? 0.5 : 0.8, duration: 0.2, ease: "power2.in"}, 0);
            rvrseTL.to(this.multipler.position, {y: ogHeight - 40, duration: 0.2}, 0)
            rvrseTL.add(() => {
                this.currentAnchor = 0.5;
                this.mainSprite.anchor.y = this.currentAnchor;
                this.setSpriteTexture(textureName);
                this.mainSprite.position.y = ogHeight * 0.5;
            }, 0.1);

            rvrseTL.add(() => {
                this.mainSprite.alpha = 1;
                this.mainSpriteContainer.removeChild(crntImg);
            }, 0.2);
            this.visualHeightStatus = ogHeight;

        }


        return rvrseTL;
    }

    private addScaleYPos(): number {
        let changeYPos: number = 0;
        if (this.visualHeightStatus === 200) {
            changeYPos = 100;
        } else if (this.visualHeightStatus === 400) {
            if (this.symID === 0) {
                changeYPos = 200;
            } else if (this.symID === 1) {
                this.symbolHeight === 2 ? changeYPos = 200 : changeYPos = 100;
            } else if (this.symID === 2) {
                changeYPos = 0;
            }
        } else if (this.visualHeightStatus == 500) {
            if (this.symID === 0) {
                changeYPos = 250;
            } else if (this.symID === 1) {
                changeYPos = 150;
            }
        } else if (this.visualHeightStatus === 600) {
            changeYPos = 300;
        }

        return changeYPos;
    }
}